import { gql } from "@apollo/client";

export const GET_ULTIMO_PASO_INDEX = gql`
  query visita($idVisita: Int!) {
    visita(idVisita: $idVisita) {
      ultimoPasoIndex
    }
  }
`;